/* eslint-disable no-console */

module.exports = {
  getPremiumStatus: function (userId) {
    return this.client.get(`/mobile/store/user/${userId}/premium_status`)
  },
}



// WEBPACK FOOTER //
// ./shared/mapmy/mobile.js